import React from 'react';
import { styled } from 'styled-components';
import THEME from '../theme.js';
const CheckboxSimple = (props) => {
    const ref = React.useRef(null);
    // `indeterminate` is a DOM-only property React does not manage, and a native
    // click clears it, so it is reapplied whenever either input state changes.
    React.useEffect(() => {
        if (ref.current) {
            ref.current.indeterminate = !!props.indeterminate;
        }
    }, [props.indeterminate, props.checked]);
    return (React.createElement(CheckboxWrapper, { className: props.className, style: props.style, onClick: (e) => {
            if (ref.current) {
                ref.current.click();
                e.stopPropagation();
            }
        } },
        React.createElement(CheckboxInput, { type: "checkbox", ref: ref, checked: props.checked, disabled: props.disabled, "aria-label": props.ariaLabel, onChange: props.onChange, onClick: props.onClick })));
};
export default CheckboxSimple;
const CheckboxInput = styled.input `
  @supports (-webkit-appearance: none) or (-moz-appearance: none) {
    -webkit-appearance: none;
    -moz-appearance: none;
    height: 16px;
    width: 16px;
    outline: none;
    display: inline-block;
    vertical-align: top;
    position: relative;
    margin: 0;
    cursor: default;
    border: 1px solid var(--bc, var(--border));
    background: var(--b, var(--background));
    transition:
      background 0.1s ease-in-out,
      border-color 0.1s ease-in-out,
      box-shadow 0.1s ease-in-out;
    border-radius: 5px;

    &:after {
      content: '';
      display: block;
      left: 0;
      top: 0;
      position: absolute;
      transition:
        transform var(--d-t, 0.3s) var(--d-t-e, ease),
        opacity var(--d-o, 0.2s);
    }

    &:checked {
      --b: var(--active);
      --bc: var(--active);
      --d-o: 0.3s;
      --d-t: 0.6s;
      --d-t-e: cubic-bezier(0.2, 0.85, 0.32, 1.2);
    }

    &:disabled {
      --b: var(--disabled);
      cursor: not-allowed;
      opacity: 0.9;
      --bc: var(--border);

      &:checked {
        --b: var(--disabled-inner);
        --bc: var(--border);
      }
    }

    &:focus {
      box-shadow: 0 0 0 var(--focus);
    }

    /* The reset above drops the outline, so keyboard focus needs its own. */
    &:focus-visible {
      outline: 2px solid var(--active);
      outline-offset: 2px;
    }

    &:not(.switch) {
      &:after {
        opacity: var(--o, 0);
        width: 4px;
        height: 7px;
        border: 2px solid var(--active-inner);
        border-top: 0;
        border-left: 0;
        left: 5px;
        top: 3px;
        transform: rotate(var(--r, 20deg));
      }

      &:checked {
        --o: 1;
        --r: 43deg;
      }

      &:indeterminate {
        --b: var(--active);
        --bc: var(--active);

        &:after {
          opacity: 1;
          width: 8px;
          height: 0;
          border: 0;
          border-bottom: 2px solid var(--active-inner);
          left: 3px;
          top: 6px;
          transform: none;
        }
      }
    }
  }
`;
const CheckboxWrapper = styled.div `
  --active: ${THEME.COLOR_ACCENT};
  --active-inner: #fff;
  --focus: 2px rgba(39, 94, 254, 0.3);
  --border: #bbc1e1;
  --border-hover: ${THEME.COLOR_ACCENT};
  --background: #fff;
  --disabled: #f6f8ff;
  --disabled-inner: #e1e6f9;

  display: flex;
  align-items: center;
  justify-content: center;
  cursor: default;

  &:hover ${CheckboxInput}:not(:checked):not(:disabled) {
    --bc: var(--border-hover);
  }

  &:has(${CheckboxInput}:disabled) {
    cursor: not-allowed;
  }
`;
//# sourceMappingURL=CheckboxSimple.js.map